import { convertEstablishmentData } from '@pedix-workspace/shared-models';
import { ApiV1_Catalog } from './api-v1.types';

export type FetchCatalogParams = {
  apiUrl: string;
  selectedLanguage?: string;
} & ({ establishmentId: string } | { slug: string });

export async function fetchCatalog(params: FetchCatalogParams) {
  const establishmentId = 'establishmentId' in params ? params.establishmentId : undefined;
  const slug = 'slug' in params ? params.slug : undefined;

  const searchParams = new URLSearchParams();

  if (params.selectedLanguage) {
    searchParams.append('language', params.selectedLanguage);
  }
  if (slug) {
    searchParams.append('useSlug', 'true');
  }

  const catalogApi = `${params.apiUrl}/establishments/${establishmentId || slug}/catalog?${searchParams.toString()}`;

  try {
    const response = await fetch(catalogApi, { signal: AbortSignal.timeout(15000) });

    if (!response.ok) {
      return null;
    }
    const responseBody = await response.json();

    return parseCatalogResponse(responseBody);
  } catch (error) {
    console.error('fetchCatalog failed', catalogApi, error);
    return null;
  }
}

function parseCatalogResponse(responseBody: any) {
  if (
    'data' in responseBody &&
    'catalogVersion' in responseBody.data &&
    responseBody.data.establishment
  ) {
    const catalog = <ApiV1_Catalog>responseBody.data;

    return {
      ...catalog,
      establishment: convertEstablishmentData(catalog.establishment.id, catalog.establishment),
    };
  }
  return null;
}
